export default {
  SET_SEARCH_SUGGESTIONS: "INFOTRADER/SET_SEARCH_SUGGESTIONS",
  SET_INFOTRADER_DATA: "INFOTRADER/SET_INFOTRADER_DATA",
  SET_LOADING_INFOTRADER_DATA: "INFOTRADER/SET_LOADING_INFOTRADER_DATA",
};
